import { useMediaQuery } from 'react-responsive';

const useIsMobile = () => {
  const isMobile = useMediaQuery({ maxWidth: 1023 });
  return isMobile;
};

export default useIsMobile;
